import { useDrop } from 'react-dnd';
import {
  Assignment,
  DragItem,
  SeverityName
} from 'store/ducks/InternalControls/types';
import { RiskInsideBpr } from './RiskInsideBpr';
import * as Styled from './InternalControlsDND.styled';
import { Popover } from 'antd';

export const BprItem: React.FC<{
  bpr: any;
  assignments: Assignment[];
  onDropRisk: (bprId: number, dragged: DragItem) => void;
  onDropControl: (
    bprId: number,
    riskInstanceId: string,
    dragged: DragItem
  ) => void;
  onDeleteAssignment: (id: string) => void;
}> = ({ bpr, assignments, onDropRisk, onDropControl, onDeleteAssignment }) => {
  const [{ isOver }, dropRef] = useDrop<DragItem, void, { isOver: boolean }>(
    () => ({
      accept: 'ITEM',
      canDrop: (item) => item.itemType === 'RISK',
      drop: (item, monitor) => {
        if (monitor.didDrop()) return;
        if (item.itemType !== 'RISK') return;
        onDropRisk(bpr.id, item);
      },
      collect: (monitor) => {
        const item = monitor.getItem() as DragItem | null;
        return {
          isOver: monitor.isOver({ shallow: true }) && item?.itemType === 'RISK'
        };
      }
    })
  );

  const risks = assignments.filter(
    (a) => a.bprId === bpr.id && a.sourceType === 'RISK'
  );

  return (
    <Styled.BprItemContainer ref={dropRef} isOver={!!isOver}>
      <Popover
        content={<div>{bpr.description || 'No description available'}</div>}
      >
        <strong style={{ cursor: 'pointer' }}>{bpr.text}</strong>
      </Popover>
      <strong>{bpr.text}</strong>
      {risks.map((risk) => {
        const severityName: SeverityName | null = risk.severity?.name ?? null;
        return (
          <RiskInsideBpr
            key={risk.assignmentId}
            risk={risk}
            severity={severityName}
            assignments={assignments}
            onDropControl={(instanceId, item) =>
              onDropControl(bpr.id, instanceId, item)
            }
            onDeleteAssignment={onDeleteAssignment}
          />
        );
      })}
    </Styled.BprItemContainer>
  );
};
